import React from 'react';

const SGiMedSettingsSection = ({ clinic, editedClinic, setEditedClinic, isEditing }) => {
  const settings = isEditing ? editedClinic?.settings : clinic?.settings;
  const sgiMedSettings = settings?.integration?.sgi_med;

  console.log('SGiMedSettingsSection - isEditing:', isEditing);
  console.log('SGiMedSettingsSection - settings:', settings);
  console.log('SGiMedSettingsSection - sgiMedSettings:', sgiMedSettings);

  const handleSGiMedSettingsChange = (field, value) => {
    if (!isEditing) return;

    setEditedClinic(prev => ({
      ...prev,
      settings: {
        ...prev.settings || {},
        integration: {
          ...prev.settings?.integration || {},
          sgi_med: {
            ...prev.settings?.integration?.sgi_med || {},
            [field]: value
          }
        }
      }
    }));
  };

  if (!isEditing) {
    // Read-only view
    return (
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-md font-semibold mb-4">SG iMed Integration</h4>

        {sgiMedSettings?.enabled ? (
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">Refresh Token</label>
              <p className="text-sm text-gray-900 mt-1">
                {sgiMedSettings.refresh_token ? '••••••••••••••••' : '-'}
              </p>
            </div>
          </div>
        ) : (
          <p className="text-gray-500">SG iMed integration is not enabled.</p>
        )}
      </div>
    );
  }

  // Edit mode
  return (
    <div className="mt-6 pt-6 border-t border-gray-200">
      <h4 className="text-md font-semibold mb-4">SG iMed Integration</h4>

      <div className="flex items-start space-x-4 mb-4">
        <div className="flex items-center h-5">
          <input
            id="sgi_med_enabled"
            name="sgi_med_enabled"
            type="checkbox"
            checked={sgiMedSettings?.enabled || false}
            onChange={(e) => handleSGiMedSettingsChange('enabled', e.target.checked)}
            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="sgi_med_enabled" className="font-medium text-gray-700">
            Enable SG iMed Integration
          </label>
          <p className="text-gray-500">
            When enabled, the system will integrate with SG iMed for enhanced functionality.
          </p>
        </div>
      </div>

      {sgiMedSettings?.enabled && (
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Refresh Token
            </label>
            <textarea
              value={sgiMedSettings?.refresh_token || ''}
              onChange={(e) => handleSGiMedSettingsChange('refresh_token', e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter refresh token"
              rows={4}
            />
            <p className="mt-1 text-xs text-gray-500">
              The refresh token for authenticating with the SG iMed API. This will be stored securely.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SGiMedSettingsSection;

